export const getQueryString = (query: Record<string, string>) => {
  return Object.entries(query)
    .filter(([key, value]) => value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&')
}
